import { render, staticRenderFns } from "./ViewFaq.vue?vue&type=template&id=9deadbaa&scoped=true"
import script from "./ViewFaq.vue?vue&type=script&lang=js"
export * from "./ViewFaq.vue?vue&type=script&lang=js"
import style0 from "./ViewFaq.vue?vue&type=style&index=0&id=9deadbaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9deadbaa",
  null
  
)

export default component.exports